import React,{ Component } from 'react';
import $ from 'jquery';
import {Link, browserHistory } from 'react-router';
import {Modal, Tab,Tabs, Col, } from 'react-bootstrap';
import Swiper from 'react-id-swiper';
// import Footer from './../Common/footer';
import { ccAvenue,razorpayForm } from "../../functions/custom_functions.js";
import {connect} from 'react-redux';
import * as actions from '../../../actions';
import Icon, { FontAwesome, Feather } from 'react-web-vector-icons';

const parseHtml = require('html-react-parser');

const baseUrl='https://aquadeals.in/admin/web3/user/';
const baseAssets = 'https://aquadeals.in/admin/assets/';
export default class Coupon_Details extends Component{
	constructor(props){
		super(props);
		this.state={
			coupon_details: [],
			coupon_status: false,
		}
		this.enq_redirect=this.enq_redirect.bind(this);
	}

enq_redirect(){
 		if(localStorage.token && localStorage.user_id){
 			localStorage.removeItem('w_r_p_dt');
 			localStorage.removeItem('w_r_s_dt');
			localStorage.removeItem('m_r_p_dt');
 			localStorage.removeItem('m_r_s_dt'); 
 			localStorage.removeItem('m_r_e_s_dt');
 			localStorage.removeItem('m_r_e_p_dt');
 			localStorage.removeItem('m_r_coupon_dt');

 			var data1={from: 'mobile_web',id:localStorage.user_id, token:localStorage.token, cid:this.props.params.Cid};
 			var data2=JSON.stringify(data1);
 			$.ajax({
 				method: 'POST',
	    		url: baseUrl+'saveCouponLead',
	      		dataType:'json',
	      		data: {req:data2},
	      		success: function(data){

	        		  if(data.status==='success'){
	        				browserHistory.push('/customer_care');	 	
	        				// window.location.reload();
	        		  }
	        	},
	  			error: function(err){

	  			}
			});
 			// browserHistory.push('/web/customer_care');
 			// window.location.reload();
 		}
 		else{
 			localStorage.removeItem('w_r_s_dt');
 			localStorage.removeItem('w_r_p_dt');
 			localStorage.removeItem('m_r_s_dt');
 			localStorage.removeItem('m_r_p_dt');
 			localStorage.removeItem('m_r_e_p_dt');
 			localStorage.removeItem('m_r_e_s_dt');

			// localStorage.setItem('m_r_coupon_dt','/coupon/details'+this.props.params.Cid); 			
 			localStorage.setItem('m_r_e_coupon_dt','/customer_care');
 			browserHistory.push('/login');
			// window.location.reload();
 		}
 	}


	componentDidMount(){

		if(screen.width >= 800){
			window.location.href="/web/coupon/details/"+this.props.params.Cid;
		}

        var data1={from: 'mobile_web', cid:this.props.params.Cid};
        var data2=JSON.stringify(data1);
        $.ajax({
            method: 'POST',
            url: baseUrl+'getCouponDetails',
            dataType:'json',
            data: {req:data2},
            success: function(data){

               //  var coupon = $.makeArray(data.coupon_details);
                //this.setState({
                //	coupon_details:coupon[0],
                //}); */}
                if(data.status==="success"){
                	var coupon = $.makeArray(data.coupon_details);
                	this.setState({
                		coupon_details:coupon[0],
                	});	
                }
                else if(data.status==="error"){
                	this.setState({
                		coupon_status: true,
                	});
                }
                }.bind(this),
            error: function(err){

            }
        })
	}

	// functions for "ADD" form validations and updations END here 
	render(){
		return(
			<div className="mob_deals coupon_details_page">

				<div id="header_main">
				<div className="page_hdr">
					<div className="container-fluid">
						<h5><Link to={'/mycart'}><i><img src={baseAssets+'images/web_imgs/back_arrow.png'} width="18px" alt=""/></i></Link>Coupon Details</h5>
						<a href="/" title="Home" className="home_logo1"><img src={baseAssets+'images/web_imgs/home1.png'} alt="Home" /></a>
					</div>
				</div>
          </div>    
          <div className="clr">&nbsp;</div>				
          <div className="clr">&nbsp;</div>				      												
			{!this.state.coupon_status ? 
			<div>
			<section className="container-fluid coupon_details_main">
				<div className="row lst_img coupon_img">
					<img src={baseAssets+"images/"+this.state.coupon_details.img} role="presentation" alt=""/>
				</div>
				<div className="row coupon_details">
					<div className="col-md-12 coupon_specs">
						{this.state.coupon_details.code ? <ul id="coupon_label"><span><li><img src={require('./../../../assets/images/coupon.png')} alt="..."></img></li><li>{this.state.coupon_details.code}</li></span></ul>  : ''}
						{this.state.coupon_details.coupon_title ? <h4>{this.state.coupon_details.coupon_title}{this.state.coupon_details.status ==1 ? <span className="coupon_status_active">ACTIVE</span> : <span className="coupon_status_expired">EXPIRED</span>}</h4> : ''}
						{this.state.coupon_details.date_time_msg ?
						<h3>{this.state.coupon_details.date_time_msg}</h3> 
							: ''} 
						{/*{this.state.coupon_details.applied_on !==0 ? <h5>{this.state.coupon_details.applied_on}</h5> : ''} */}
						
						{/*{this.state.coupon_details.value_msg !==0 ? <h5>{this.state.coupon_details.value_msg}</h5>: ''}*/}
						{/*{this.state.coupon_details.count_msg !==0 ? <h5>{this.state.coupon_details.count_msg}</h5> : ''}*/}						
						{/*{this.state.coupon_details.time_msg !==0 ? <h5>{this.state.coupon_details.time_msg}</h5>: ''}*/}
					</div>												
				</div>		
			</section>
			<div className="coupon_specs_sub_bg">
			<section className="coupon_specs_sub">
				{this.state.coupon_details.applied_on_name!==0 ? <h5>{this.state.coupon_details.applied_on_name}{this.state.coupon_details.value !==0 ? '' : ''}</h5> : ''}					
				{this.state.coupon_details.quantity_msg !==0 ? <h5><Icon
	                    name='circle'
	                    font='MaterialCommunityIcons'
	                    color='#ccc'
	                    size={14}
	                    style={{paddingRight:'3px',top:'1',position:'relative'}}
	                  />{this.state.coupon_details.quantity_msg} </h5> : ''}
				{this.state.coupon_details.applied_on_catname!==0 ? <h5><Icon
	                    name='circle'
	                    font='MaterialCommunityIcons'
	                    color='#ccc'
	                    size={14}
	                    style={{paddingRight:'3px',top:'1',position:'relative'}}
	                  />{this.state.coupon_details.applied_on_catname}</h5>: ''}
			</section>				
			<div className="coupon_dots_blocks"></div>	
			<section className="container-fluid">
				<div className="row coupon_description_blk">
					<div className="col-md-12 col-xs-12 col-sm-12 coupon_description_head">
						{this.state.coupon_details.desc ? <h4>{this.state.coupon_details.desc}</h4> : ''}
					</div>
				</div>
			</section>
			</div>
					<div className="clr">&nbsp;</div>										
					<div className="clr">&nbsp;</div>										
					<div className="clr">&nbsp;</div>
			</div> : <div className="row" style={{textAlign: 'center',color: '#555',margin:'30% auto'}}>No Coupons Available</div> } 

				  	 	
							{/*<div className="empty_checkout">Empty cart</div>*/}
							<section className="botm_btns row" style={{paddingBottom:'5px'}}>
								<ul>	
									<li className="col-md-6 col-xs-6 col-sm-6" style={{cursor:'pointer'}}>
										<Link to={'/customer_care'}><i><img src={baseAssets+'images/icons/enquiry_now.png'} alt=" " /></i>Enquire Now</Link>
									</li>
									<li className="col-md-6 col-xs-6 col-sm-6" style={{cursor: 'pointer'}}>
										<Link to={'/'}>Explore Deals</Link>
									</li>
								</ul>
							</section>
						</div>
		);
	}
}


/** WEBPACK FOOTER **
 ** ./src/components/Categories/Coupons/coupon_details.js
 **/